/* eslint-disable eqeqeq */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api"; 
import { toast } from "react-toastify";

const ProjectSelectionPage = ({ setCurrentUser }) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    
    if (currentUser.role === "ADMIN") {
        navigate("/overview");
        return;
    }

    localStorage.removeItem("selectedProjectId");

    const fetchProjects = async () => {
      try {
        const res = await api.get("/vres/projects/my-projects");
        setProjects(res.data);
      } catch (err) {
        console.error("Failed to load projects", err);
        if(err.response?.status !== 404) {
           toast.error("Could not retrieve project list.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, [navigate]);

  const getNavMenus = (role) => {
    switch (role) {
      case "PROJECT COORDINATOR": 
      case "PROJECT_COORDINATOR": 
        return ["overview", "user-registration", "create-project", "dashboard"];
      case "MAKER": return ["overview", "beneficiary-list"];
      case "CHECKER": return ["overview", "approve-beneficiary-list"];
      case "ISSUER": return ["overview", "create-voucher"];
      case "VENDOR": return ["vendor-dashboard"];
      case "OBSERVER": return ["overview", "dashboard"];
      default: return ["overview"];
    }
  };

  const handleSelectProject = (project) => {
    const newRole = project.role ? project.role.toUpperCase() : "USER";
    const newNav = getNavMenus(newRole);

    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
    
    const updatedUser = { 
        ...currentUser, 
        role: newRole, 
        selectedProjectId: project.projectId,
        nav: newNav 
    };

    localStorage.setItem("currentUser", JSON.stringify(updatedUser));
    localStorage.setItem("role", newRole);
    localStorage.setItem("selectedProjectId", project.projectId);

    if (setCurrentUser) {
        setCurrentUser(updatedUser);
    }

    // ✅ FIX: Use 'title' because your API sends "title": "test0512"
    toast.success(`Entered ${project.title}`);
    
    if (newRole === "VENDOR") {
        navigate("/vendor-dashboard");
    } else {
        navigate("/overview"); 
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    if (setCurrentUser) {
        setCurrentUser(null);
    }
    navigate("/login");
  };

  const ModalStyles = () => (
    <style>{`
      .project-modal-overlay {
        position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;
        background-color: rgba(0, 0, 0, 0.6); backdrop-filter: blur(4px); 
        z-index: 9999; display: flex; justify-content: center; align-items: center;
      }
      .project-modal {
        background: white; width: 90%; max-width: 800px;
        border-radius: 12px; box-shadow: 0 20px 50px rgba(0,0,0,0.3);
        padding: 40px; animation: slideIn 0.3s ease-out;
        max-height: 85vh; overflow-y: auto; position: relative;
      }
      @keyframes slideIn {
        from { opacity: 0; transform: translateY(-30px); }
        to { opacity: 1; transform: translateY(0); }
      }
      .project-list-table {
        width: 100%; border-collapse: collapse; margin-top: 25px;
      }
      .project-list-table th {
        text-align: left; padding: 15px; background-color: #f8f9fa;
        color: #6c757d; font-weight: 600; border-bottom: 2px solid #e9ecef;
        text-transform: uppercase; font-size: 0.85rem;
      }
      .project-list-table td {
        padding: 16px 15px; border-bottom: 1px solid #f1f3f5;
        vertical-align: middle; color: #2d3436;
      }
      .project-row { cursor: pointer; transition: all 0.2s; }
      .project-row:hover { background-color: #f8fffc; transform: scale(1.005); }
      .status-pill {
        display: inline-block; padding: 5px 12px; border-radius: 20px;
        font-size: 0.75rem; font-weight: 700; text-transform: uppercase;
      }
      .status-active { background-color: #d1e7dd; color: #0f5132; }
      .status-draft { background-color: #fff3cd; color: #856404; }
      .role-tag {
        background-color: #e3f2fd; color: #0d47a1; padding: 5px 10px; 
        border-radius: 6px; font-size: 0.85rem; font-weight: 500;
      }
      .select-btn {
        background-color: #007bff; color: white; border: none; padding: 8px 20px;
        border-radius: 6px; cursor: pointer; font-size: 0.9rem; transition: background-color 0.2s; font-weight: 500;
      }
      .select-btn:hover { background-color: #0056b3; }
      .modal-logout-btn {
        position: absolute; top: 20px; right: 20px;
        background-color: transparent; color: #dc3545;
        border: 1px solid #dc3545; padding: 6px 15px;
        border-radius: 6px; cursor: pointer; font-size: 0.85rem; font-weight: 600;
        transition: all 0.2s;
      }
      .modal-logout-btn:hover { background-color: #dc3545; color: white; }
    `}</style>
  );

  return (
    <div className="project-modal-overlay">
      <ModalStyles />
      <div className="project-modal">
        <button className="modal-logout-btn" onClick={handleLogout}>Logout</button>

        <h2 style={{ textAlign: 'center', margin: '0 0 10px 0', color: '#2d3436' }}>Select a Project</h2>
        <p style={{ textAlign: 'center', color: '#636e72', marginBottom: '10px' }}>
          Select the project environment you wish to access.
        </p>

        {loading ? (
          <div style={{textAlign: 'center', padding: '40px', color: '#666'}}>
            <i className="fa-solid fa-spinner fa-spin" style={{marginRight: '10px'}}></i> Loading projects...
          </div>
        ) : projects.length === 0 ? (
          <div style={{textAlign: 'center', padding: '40px', color: '#dc3545', backgroundColor: '#fff5f5', borderRadius: '8px', marginTop: '20px'}}>
            <strong>No Projects Found.</strong> <br/> You are not currently assigned to any active projects.
          </div>
        ) : (
          <table className="project-list-table">
            <thead>
              <tr>
                <th>Project Name</th>
                <th>Assigned Role</th>
                <th>Status</th>
                <th style={{textAlign: 'right'}}>Action</th>
              </tr>
            </thead>
            <tbody>
              {projects.map((p) => (
                <tr key={p.projectId} className="project-row" onClick={() => handleSelectProject(p)}>
                  
                  {/* ✅ FIX: Use 'p.title' instead of 'p.projectName' to match JSON */}
                  <td><strong style={{fontSize: '1rem', color: '#2d3436'}}>{p.title}</strong></td>
                  
                  <td><span className="role-tag">{p.role}</span></td>
                  
                  <td>
                    <span className={`status-pill status-active`}>
                      Active
                    </span>
                  </td>
                  <td style={{textAlign: 'right'}}><button className="select-btn">Enter</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default ProjectSelectionPage;